import { getHostHelpers } from '../Utils/hostHelpers'

export function useHistory() {
  const context = getHostHelpers()
  return context.history
}
